import React, { VFC } from 'react';
import { DashboardHomeCommonConfirmPanelProps } from './delete-confirm-panel';
import classNames from 'classnames';

import { LeftStrongIcon } from 'src/monet/icons';
import { SmallPanel } from 'src/common/ui/small-panel';

export const DashboardHomeDuplicateConfirmPanel: VFC<DashboardHomeCommonConfirmPanelProps> = ({
  content,
  onConfirm,
  onDeny,
  onBack,
  confirmText,
  denyText,
  containerClassName,
  ...popoverProps
}) => {
  return (
    <SmallPanel openAfterMount containerClassName={containerClassName} hasBackButton onBack={onBack} {...popoverProps}>
      <div className='flex flex-col space-y-md text-bedrock-black'>
        <div className='text-bedrock-p cursor-default'>{content}</div>
        <div className='flex items-center space-x-2'>
          <button type='button' className='btn-bedrock-primary' onClick={onConfirm}>
            {confirmText}
          </button>
          <button type='button' className='btn-bedrock-secondary' onClick={onDeny}>
            {denyText}
          </button>
        </div>
      </div>
    </SmallPanel>
  );
};
